import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { OverlayPanel } from "primereact/overlaypanel";
import { Button } from "primereact/button";
import { forwardRef, useRef, ForwardedRef, useState, useEffect } from "react";
import PortalController from "../../pages/PublicPage/controller/portal.controller";

interface ShareModalProps {
  url: string;
}

export const ShareModal = forwardRef(
  ({ url }: ShareModalProps, ref: ForwardedRef<OverlayPanel>) => {
    const [email, setEmail] = useState("");
    const [note, setNote] = useState("");
    const [emailError, setEmailError] = useState("");
    const controller = new PortalController();

    const validateEmail = (email: string): boolean => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    };

    const handleButtonClick = (e: any) => {
      e.stopPropagation(); // Impede que o clique no botão dispare o clique da div
    };

    const handleShare = async () => {
      if (!email) {
        setEmailError("E-mail é obrigatório");
        return;
      }

      if (!validateEmail(email)) {
        setEmailError("Por favor, insira um e-mail válido");
        return;
      }

      setEmailError("");
      await controller.shareEvent({
        dsLink: url,
        dsEmail: email,
        dsNota: note || "",
      });

      setEmail("");
      setNote("");
      (ref as React.MutableRefObject<OverlayPanel>)?.current?.hide();
    };

    return (
      <OverlayPanel ref={ref} style={{ width: "300px" }}>
        <div className="flex flex-column gap-3">
          <div className="field">
            <label htmlFor="url" className="block mb-2">
              Link para o filtro
            </label>
            <InputText id="url" value={url} className="w-full" readOnly />
          </div>
          <div className="field">
            <label htmlFor="email" className="block mb-2">
              E-mail
            </label>
            <InputText
              id="email"
              className={`w-full ${emailError ? "p-invalid" : ""}`}
              placeholder="Digite o e-mail"
              value={email}
              onClick={(e) => handleButtonClick(e)}
              onChange={(e) => {
                setEmail(e.target.value);
                if (emailError) setEmailError("");
              }}
            />
            {emailError && <small className="p-error">{emailError}</small>}
          </div>
          <div className="field">
            <label htmlFor="note" className="block mb-2">
              Nota
            </label>
            <InputTextarea
              id="note"
              className="w-full"
              rows={3}
              placeholder="Adicionar uma nota opcional"
              value={note}
              onClick={(e) => handleButtonClick(e)}
              onChange={(e) => setNote(e.target.value)}
            />
          </div>
          <div className="flex gap-2 justify-content-end">
            <Button label="Compartilhar" onClick={(e) => {handleButtonClick(e); handleShare()}} />
            <Button
              label="Cancelar"
              className="p-button-secondary p-button-outlined"
              onClick={(e) =>{
                handleButtonClick(e);
                (ref as React.MutableRefObject<OverlayPanel>)?.current?.hide()
              }}
            />
          </div>
        </div>
      </OverlayPanel>
    );
  }
);

ShareModal.displayName = "ShareModal";
